export default (baseUrl: string) => ({
  bankmodule: {
    emailVerification: `${baseUrl}/api/bankmodule/verifyemail`,
  },
  login: `${baseUrl}/api/auth/login`,
  logout: `${baseUrl}/logout`,
  userInfo: `${baseUrl}/api/auth/userInfo`,
  sessionInfo: `${baseUrl}/api/auth/sessionInfo`,
  requestPasswordReset: `${baseUrl}/api/auth/requestPasswordReset`,
  resetPassword: `${baseUrl}/api/auth/resetPassword`,
  personalData: `${baseUrl}/api/personalData`,
  changeAddress: `${baseUrl}/api/personalData/changeAddress`,
  country: `${baseUrl}/api/country`,
  changePhone: `${baseUrl}/api/personalData/changePhone`,
  changeName: `${baseUrl}/api/personalData/changeName`,
  changeEmail: `${baseUrl}/api/personalData/changeEmail`,
  getMaritalStatuses: `${baseUrl}/api/personalData/getMaritalStatuses`,
  register: `${baseUrl}/api/registration`,
  requestVerificationEmail: `${baseUrl}/api/registration/requestVerificationEmail`,
  contracts: `${baseUrl}/api/contract`,
  expiringContracts: `${baseUrl}/api/contract/expiringContracts`,
  updateExpiringContracts: `${baseUrl}/api/contract/expiringContracts`,
  calculateTransferFee: `${baseUrl}/api/earlyTermination/calculateTransferFee`,
  requestEarlyTermination: `${baseUrl}/api/earlyTermination/requestEarlyTermination`,
  earlyTerminationPdf: `${baseUrl}/api/earlyTermination/pdf/`,
  earlyTerminationInfoPdf: `${baseUrl}/api/earlyTermination/infoPdf`,
  getRedemptionPlan: `${baseUrl}/api/contract/redemptionPlan`,
  getBankStatement: `${baseUrl}/api/contract/bankStatement`,
  businessTransactions: `${baseUrl}/api/businessTransaction/all`,
  bankDetailsByIban: `${baseUrl}/api/sepa/bankDetailsByIban/`,
  changeBankConnection: `${baseUrl}/api/changePayment/bankConnectionChange`,
  recentAddressChange: `${baseUrl}/api/personalData/recentAddressChange`,
  vehicleLetterShipment: `${baseUrl}/api/vehicleLetterShipment`,
  generateSepaMandate: `${baseUrl}/api/changePayment/sepaMandate`,
  downloadSepaMandate: `${baseUrl}/api/changePayment/pdf/sepaMandate`,
  newMandateNeeded: `${baseUrl}/api/changePayment/newMandateNeeded`,
  searchInsurances: `${baseUrl}/api/caseOfDamage/searchInsurances`,
  reportCaseOfDamage: `${baseUrl}/api/caseOfDamage`,
  searchOffices: `${baseUrl}/api/vehicleLetterShipment/searchOffices`,
  getCityForPostalCode: `${baseUrl}/api/address/cityForPostalCode`,
  getStreetsForPostalCodeAndCity: `${baseUrl}/api/address/streetsForPostalCodeAndCity`,
  verifyEmailRegistration: `${baseUrl}/api/registration/verifyEmail/registration`,
  verifyEmailForgotEmail: `${baseUrl}/api/registration/verifyEmail/forgotEmail`,
  postboxMessage: `${baseUrl}/api/message`,
  getPostboxMessages: `${baseUrl}/api/message/all`,
  checkVehicleLetterShipments: `${baseUrl}/api/vehicleLetterShipment/checkVehicleLetterShipments`,
  deleteAccount: `${baseUrl}/api/account`,
  getTerminationDates: `${baseUrl}/api/contract/terminationDates`,
  getVehicle: `${baseUrl}/api/contract/vehicle`,
  getDealer: `${baseUrl}/api/contract/dealer`,
  getBankDetails: `${baseUrl}/api/contract/bankDetails`,
  getContractor: `${baseUrl}/api/contract/contractor`,
  getAllVehicles: `${baseUrl}/api/contract/vehicle/all`,
  getAllBankDetails: `${baseUrl}/api/changePayment/bankDetails/all`,
  getAllContractors: `${baseUrl}/api/contract/contractor/all`,
  validateResetPasswordToken: `${baseUrl}/api/auth/validateResetPasswordToken`,
  requestPasswordResetLink: `${baseUrl}/api/auth/requestPasswordResetLink`,
  hasIbanChanged: `${baseUrl}/api/changePayment/ibanChanged`,
  getUnreadMessagesCount: `${baseUrl}/api/message/unreadCount`,
  markAsRead: `${baseUrl}/api/message/markAsRead`,
  pdf: `${baseUrl}/api/misc/pdf`,
  changePassword: `${baseUrl}/api/account/changePassword`,
  registrationViaDealer: `${baseUrl}/api/registration/dealer`,
  validateOnlineleasingRegistrationToken: `${baseUrl}/api/registration/validateOnlinedealToken`,
  confirmDealerRegistration: `${baseUrl}/api/registration/dealer/confirm`,
  confirmOnlineleasingRegistration: `${baseUrl}/api/registration/onlinedeal/confirm`,
  contactFormMessage: `${baseUrl}/api/message/contactform`,
  buildInfo: `${baseUrl}/api/misc/build`,
  updateVersionTermsOfUse: `${baseUrl}/api/account/updateVersionTermsOfUse`,
  downloadPortalDocument: `${baseUrl}/api/document/downloadDocument`,
  getVehicleLetterFee: `${baseUrl}/api/vehicleLetterShipment/vehicleLetterFee`,
  getRsvLrvApplication: `${baseUrl}/api/rsvLrvApplication`,
  getRsvLrvPlusApplication: `${baseUrl}/api/rsvLrvApplication/plus`,
  requestDefermentOfPayment: `${baseUrl}/api/delayOfPayment`,
  calculateDefermentOfPayment: `${baseUrl}/api/delayOfPayment/calculate`,
  requestPaymentDateChange: `${baseUrl}/api/paymentDateChange`,
  specialRepayment: `${baseUrl}/api/specialRepayment`,
  downtime: `${baseUrl}/api/misc/downtime`,
  logError: `${baseUrl}/api/log/error`,
  toyaAddress: `${baseUrl}/api/onlinedeal/address`,
  toyaPersonalData: `${baseUrl}/api/onlinedeal/personalData`,
  toyaIdentificationData: `${baseUrl}/api/onlinedeal/identificationData`,
  toyaBudget: `${baseUrl}/api/onlinedeal/budget`,
  toyaCalculation: `${baseUrl}/api/onlinedeal/calculation`,
  toyaPrivateData: `${baseUrl}/api/onlinedeal/privateData`,
  toyaEmployers: `${baseUrl}/api/onlinedeal/employers`,
  toyaAgreements: `${baseUrl}/api/onlinedeal/agreements`,
  toyaAgreementsOL: `${baseUrl}/api/onlinedeal/agreementsOL`,
  updateAgreementsAndPrintOFS: `${baseUrl}/api/onlinedeal/agreementsAndPrintOFS`,
  toyaVehicleConfigSummary: `${baseUrl}/api/onlinedeal/vehicle-config-summary`,
  webIdUrl: `${baseUrl}/api/onlinedeal/webIdUrl`,
  toyaBankData: `${baseUrl}/api/onlinedeal/bankData`,
  toyaBankInquiryData: `${baseUrl}/api/onlinedeal/bankInquiryData`,
  toyaOverviewData: `${baseUrl}/api/onlinedeal/overview`,
  toyaUpload: `${baseUrl}/api/onlinedeal/uploadFiles`,
  toyaDocuments: `${baseUrl}/api/onlinedeal/documents`,
  toyaContractConfirmationData: `${baseUrl}/api/onlinedeal/contractconfirmation`,
  status: `${baseUrl}/api/onlinedeal/status`,
  tobiasstatus: `${baseUrl}/api/onlinedeal/tobiasstatus`,
  checkTan: `${baseUrl}/api/onlinedeal/checkTan`,
  toyaDealer: `${baseUrl}/api/onlinedeal/dealerInformation`,
  sendSmsTan: `${baseUrl}/api/onlinedeal/sendSmsTan`,
  printContractOL: `${baseUrl}/api/onlinedeal/printContractOL`,
  toyaContract: `${baseUrl}/api/onlinedeal/contract`,
  toyaContractHead: `${baseUrl}/api/onlinedeal/contractHead`,
  toyaSignedContract: `${baseUrl}/api/onlinedeal/signedContract`,
  printDownloadDocuments: `${baseUrl}/api/onlinedeal/printDownloadDocuments`,
  signPdf: `${baseUrl}/api/onlinedeal/signPdf`,
  calculations: `${baseUrl}/api/onlinedeal/calculations`,
  uploadFile: `${baseUrl}/api/onlinedeal/upload`,
  openApplications: `${baseUrl}/api/onlinedeal/openApplications`,
  legitimationStatus: `${baseUrl}/api/onlinedeal/legitimationStatus`,
  getSpecialRepaymentFee: `${baseUrl}/api/specialRepayment/specialRepaymentFee`,
  customerType: `${baseUrl}/api/onlinedeal/customerType`,
  soleTraderData: `${baseUrl}/api/onlinedeal/soleTraderData`,
  vehicleImageURL: `${baseUrl}/api/onlinedeal/vehicleImageURL`,
  lastChangedBy: `${baseUrl}/api/onlinedeal/lastChangedBy`,
  i18n: `${baseUrl}/api/misc/i18n/`,
  isProductValid: `${baseUrl}/api/onlinedeal/isProductValid`,
  isPersonLegitimated: `${baseUrl}/api/onlinedeal/isPersonLegitimated`,
  newsletter: `${baseUrl}/api/newsletter`,
  showReportingAU: `${baseUrl}/api/contract/showReportingAU`,
  contractInfoData: `${baseUrl}/api/contract/:contractNumber/contractInfo`,
  caseOfDamageData: `${baseUrl}/api/contract/:contractNumber/caseOfDamage`,
  allCaseOfDamageData: `${baseUrl}/api/contract/caseOfDamage`,
  vehicleLetterData: `${baseUrl}/api/contract/:contractNumber/vehicleLetter`,
  allVehicleLetterData: `${baseUrl}/api/contract/vehicleLetter`,
  specialRepaymentData: `${baseUrl}/api/contract/:contractNumber/specialRepayment`,
  delayOfPaymentData: `${baseUrl}/api/contract/:contractNumber/defermentOfPayment`,
  earlyTerminationData: `${baseUrl}/api/contract/:contractNumber/earlyTermination`,
  changeAllPaymentData: `${baseUrl}/api/contract/changePayment`,
  paymentDateChangeData: `${baseUrl}/api/contract/:contractNumber/paymentDateChange`,
  keycloak: `${baseUrl}/oauth2/authorization/keycloak`,
  checkEmailChangeToken: `${baseUrl}/api/auth/checkEmailChangeToken`,
  industryCodes: `${baseUrl}/api/industry`,
});
